<template>
    <!-- MODALS -->
    <modal name="confirm-bid" @closed="close">
        <div v-if="lot" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <transition
                    enter-active-class="ease-out duration-300"
                    enter-from-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-from-class="opacity-100"
                    leave-to-class="opacity-0">

                    <div @click.prevent="$modal.hide('confirm-bid')" class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" aria-hidden="true"></div>

                </transition>

                <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

                <transition
                    enter-active-class="ease-out duration-300"
                    enter-from-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-from-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">

                    <div class="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full sm:p-6">
                        <div class="hidden sm:block absolute top-0 right-0 pt-4 pr-4">
                            <button @click="$modal.hide('confirm-bid')" type="button" class="bg-white rounded-md text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500">
                                <span class="sr-only">{{ $t('general.close') }}</span>
                                <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                                </svg>
                            </button>
                        </div>
                        <div class="sm:flex sm:items-start">
                            <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-green-100 sm:mx-0 sm:h-10 sm:w-10">
                                <svg class="h-6 w-6 text-green-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
                                </svg>
                            </div>
                            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">{{ $t('bids.confirmation') }}</h3>
                                <div class="mt-2">
                                    <p class="text-sm text-gray-500">{{ $t('bids.confirmation_info') }} {{ lot.no }} - {{ description }}?</p>
                                </div>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
                            <button @click.prevent="bid" type="button" class="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-green-600 text-base font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-500 sm:ml-3 sm:w-auto sm:text-sm">
                                <span v-if="canBid" class="flex">
                                    <span>{{ $t('bids.bid') }}</span>
                                    <span class="mx-1">
                                        <money-format
                                            :value="lot.k"
                                            locale="ro"
                                            currency-code="eur"
                                            :subunits-value="false"
                                            :hide-subunits="true">
                                        </money-format>
                                    </span>
                                </span>
                            </button>
                            <button @click.prevent="$modal.hide('confirm-bid')" type="button" class="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:mt-0 sm:w-auto sm:text-sm">{{ $t('general.cancel') }}</button>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Constants } from '../../constants'

export default {
    data () {
        return {
            ...Constants
        }
    },
    computed: {
        ...mapGetters({
            user: 'getUser',
            lot: 'getLot',
            bids: 'getBids',
            winner: 'getWinner',
        }),
        canBid () {
            if(this.lot.s != this.LOT_AUCTION_STATUS_OPEN) return false
            if(! this.user.id) return false
            if(this.winner && (this.winner.uid === this.user.id && this.lot.k != this.lot.r)) return false
            if(this.bids.filter(el => el.uid == this.user.id).length > 0) return false
            return true
        },
        description () {
            let artist = ''
            if(this.lot.a) {
                artist = this.lot.a + ', '
            }
            return artist + this.lot.t
        }
    },
    methods: {
        bid () {
            this.$emit('confirmbid')
        },
        close () {
            this.$emit('cancel')
        }
    }
}
</script>
